/**
 * 숫자를 지정된 자릿수로 패딩하여 문자열로 반환합니다.
 * 기본적으로 2자리로 패딩하며, 1자리 숫자인 경우 앞에 0을 붙입니다.
 *
 * @param value - 패딩할 숫자
 * @param length - 패딩할 자릿수 (기본값: 2)
 * @returns 패딩된 문자열
 *
 * @example
 * // 1 -> "01"
 * padNumber(1);
 *
 * // 10 -> "10"
 * padNumber(10);
 *
 * // 5 -> "005" (length가 3인 경우)
 * padNumber(5, 3);
 */
export const padNumber = (value: number, length: number = 2): string => {
  return String(value).padStart(length, '0');
};
